import { FormattedMessage } from "react-intl";

import { Span } from "@aglocal/web/components/Typography";

export default function Copyright() {
  const year = new Date().getFullYear();
  return (
    <Span variant="body1Strong">
      <FormattedMessage
        defaultMessage="Copyright © {year} Allegis Group"
        description="Copyright line in the page footer; {year} is the current year and Allegis Group is the company name."
        values={{ year: String(year) }}
      />
    </Span>
  );
}
